import { render, staticRenderFns } from "./SubMenuCard.vue?vue&type=template&id=a4a0b314&scoped=true&"
import script from "./SubMenuCard.vue?vue&type=script&lang=js&"
export * from "./SubMenuCard.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuCard.vue?vue&type=style&index=0&id=a4a0b314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a0b314",
  null
  
)

export default component.exports